import { Injectable } from '@angular/core';
import { ErrorHandlerService } from '@examdojo/core/error-handling';
import { EMPTY, finalize, Observable, tap } from 'rxjs';
import { BillingHttpService } from './billing-http.service';
import { Currency } from './currency.model';
import { CurrencyQuery } from './currency.query';
import { CurrencyStore } from './currency.store';

@Injectable({ providedIn: 'root' })
export class CurrencyService {
  constructor(
    private readonly currencyStore: CurrencyStore,
    private readonly currencyQuery: CurrencyQuery,
    private readonly billingHttpService: BillingHttpService,
    private readonly errorHandlerService: ErrorHandlerService,
  ) {}

  /**
   * Get currencies from store, fetching from API if needed
   */
  getCurrencies(): Observable<Currency[]> {
    // Fetch once if we don't have currencies yet
    if (this.currencyQuery.getCurrencies().length === 0 && !this.currencyQuery.isLoading()) {
      this.fetchCurrencies();
    }

    return this.currencyQuery.selectCurrencies();
  }

  /**
   * Fetch currencies from API
   */
  private fetchCurrencies(): void {
    this.currencyStore.updateStore((state) => ({
      ...state,
      loading: true,
    }));

    this.billingHttpService
      .getCurrencies()
      .pipe(
        tap((currencies) => {
          this.currencyStore.updateStore((state) => ({
            ...state,
            currencies,
          }));
        }),
        this.errorHandlerService.catchError('[CurrencyService]: Failed to fetch currencies', () => EMPTY),
        finalize(() => {
          this.currencyStore.updateStore((state) => ({
            ...state,
            loading: false,
          }));
        }),
      )
      .subscribe();
  }
}
